/** What the viewer says about a file it cannot read (#11277). It says only
 *  what is known: a locked Office file is password-protected; any other
 *  cannot be read as the format its name claims. Opened from somewhere that
 *  did not carry the reason, it says no more than that it cannot be read. */
export const unreadableMessage = (
  reason: "encrypted" | "no_signature" | null | undefined,
  fileName: string | undefined
): string => {
  if (reason === "encrypted")
    return "This file is password-protected and can't be read here.";
  const name = fileName ?? "";
  const dot = name.lastIndexOf(".");
  const ext = dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
  if (reason === "no_signature" && ext)
    return `This file can't be read as a .${ext} file.`;
  return "This file can't be read.";
};
